import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import TabNavigation from '../Navigation/TabNavigation';
import './TopHeader.css';

// Import CDC logo
// import { ReactComponent as CDCLogo } from '../../assets/icons/cdc-logo.svg';
import MainLogo from '../../assets/images/header-logo.png';

interface TopHeaderProps extends WithTranslation {
  isAuthenticated?: boolean;
  className?: string;
}

interface TopHeaderState {}

class TopHeader extends Component<TopHeaderProps, TopHeaderState> {
  constructor(props: TopHeaderProps) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      isAuthenticated = false,
      className = ''
    } = this.props;

    return (
      <header className={`top-header ${className}`}>
        <div className="top-header-inner">
          <div className="top-header-left">
            <div className="logo-container">
              {/* <CDCLogo className="cdc-logo" /> */}
              <Link to="/" ><img src={MainLogo} alt="Main Logo" className="main-logo" /></Link>
            </div>
          </div>
          
          <div className="top-header-center">
            {/* Empty center area for now */}
          </div>
          
          <div className="top-header-right">
            <TabNavigation isAuthenticated={isAuthenticated} />
          </div>
        </div>
      </header>
    );
  }
}

export default withTranslation()(TopHeader);
